var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009f77;}.cls-2{fill:#5ec09b;}.cls-3{fill:#e92949;}.cls-4{fill:#009d54;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.92,73.39l8-27.57a16.52,16.52,0,0,1,8.5-10.2l0,0a6.13,6.13,0,0,0,3.38-5.48h0A6.12,6.12,0,0,0,141.69,24H114.31a6.12,6.12,0,0,0-6.12,6.12h0a6.13,6.13,0,0,0,3.38,5.48h0a16.5,16.5,0,0,1,8.52,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.92,182.61l8,27.57a16.52,16.52,0,0,0,8.5,10.2l0,0a6.13,6.13,0,0,1,3.38,5.48h0a6.12,6.12,0,0,1-6.12,6.12H114.31a6.12,6.12,0,0,1-6.12-6.12h0a6.13,6.13,0,0,1,3.38-5.48h0a16.5,16.5,0,0,0,8.52-10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.39,128.08l-27.57-8a16.52,16.52,0,0,1-10.2-8.5l0,0a6.13,6.13,0,0,0-5.48-3.38h0A6.12,6.12,0,0,0,24,114.31v27.38a6.12,6.12,0,0,0,6.12,6.12h0a6.13,6.13,0,0,0,5.48-3.38h0a16.5,16.5,0,0,1,10.27-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.61,128.08l27.57-8a16.52,16.52,0,0,0,10.2-8.5l0,0a6.13,6.13,0,0,1,5.48-3.38h0a6.12,6.12,0,0,1,6.12,6.12v27.38a6.12,6.12,0,0,1-6.12,6.12h0a6.13,6.13,0,0,1-5.48-3.38h0a16.5,16.5,0,0,0-10.27-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.33,89.44,75.47,64.31a16.55,16.55,0,0,1-1.21-13.22l0,0a6.14,6.14,0,0,0-1.48-6.27h0a6.13,6.13,0,0,0-8.66,0l-9.68,9.68-9.68,9.68a6.13,6.13,0,0,0,0,8.66h0a6.14,6.14,0,0,0,6.27,1.48h0a16.53,16.53,0,0,1,13.28,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.56,166.67l25.13,13.86a16.55,16.55,0,0,0,13.22,1.21l0,0a6.14,6.14,0,0,1,6.27,1.48h0a6.13,6.13,0,0,1,0,8.66l-9.68,9.68-9.68,9.68a6.13,6.13,0,0,1-8.66,0h0a6.14,6.14,0,0,1-1.48-6.27h0a16.53,16.53,0,0,0-1.24-13.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.44,166.67,64.31,180.53a16.55,16.55,0,0,1-13.22,1.21l0,0a6.14,6.14,0,0,0-6.27,1.48h0a6.13,6.13,0,0,0,0,8.66l9.68,9.68,9.68,9.68a6.13,6.13,0,0,0,8.66,0h0A6.14,6.14,0,0,0,74.28,205h0a16.53,16.53,0,0,1,1.24-13.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.67,89.44l13.86-25.13a16.55,16.55,0,0,0,1.21-13.22l0,0a6.14,6.14,0,0,1,1.48-6.27h0a6.13,6.13,0,0,1,8.66,0l9.68,9.68,9.68,9.68a6.13,6.13,0,0,1,0,8.66h0A6.14,6.14,0,0,1,205,74.28h0a16.53,16.53,0,0,0-13.28,1.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 128,
    cy: 128,
    r: 69.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 142.86,
    cy: 98.29,
    r: 14.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 137.9,
    cy: 152.76,
    r: 19.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 93.33,
    cy: 123.05,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 108.19,
    cy: 93.33,
    r: 4.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 93.33,
    cy: 157.71,
    r: 4.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 172.57,
    cy: 128,
    r: 4.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M319.87,231.79l12.88-44.54a26.75,26.75,0,0,1,13.72-16.49l.06,0a9.89,9.89,0,0,0,5.47-8.84h0a9.89,9.89,0,0,0-9.89-9.89H297.89a9.89,9.89,0,0,0-9.89,9.89h0a9.89,9.89,0,0,0,5.47,8.84h0a26.73,26.73,0,0,1,13.75,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M319.87,408.21l12.88,44.54a26.75,26.75,0,0,0,13.72,16.49l.06,0a9.89,9.89,0,0,1,5.47,8.84h0a9.89,9.89,0,0,1-9.89,9.89H297.89a9.89,9.89,0,0,1-9.89-9.89h0a9.89,9.89,0,0,1,5.47-8.84h0a26.73,26.73,0,0,0,13.75-16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.79,320.13l-44.54-12.88a26.75,26.75,0,0,1-16.49-13.72l0-.06a9.89,9.89,0,0,0-8.84-5.47h0a9.89,9.89,0,0,0-9.89,9.89v44.22a9.89,9.89,0,0,0,9.89,9.89h0a9.89,9.89,0,0,0,8.84-5.47h0a26.73,26.73,0,0,1,16.6-13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408.21,320.13l44.54-12.88a26.75,26.75,0,0,0,16.49-13.72l0-.06a9.89,9.89,0,0,1,8.84-5.47h0a9.89,9.89,0,0,1,9.89,9.89v44.22a9.89,9.89,0,0,1-9.89,9.89h0a9.89,9.89,0,0,1-8.84-5.47h0a26.73,26.73,0,0,0-16.6-13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.53,257.71l-22.39-40.59a26.77,26.77,0,0,1-1.95-21.37l0-.06a9.89,9.89,0,0,0-2.38-10.12h0a9.9,9.9,0,0,0-14,0l-15.63,15.64-15.64,15.63a9.9,9.9,0,0,0,0,14h0a9.89,9.89,0,0,0,10.12,2.38h0a26.74,26.74,0,0,1,21.46,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.29,382.47l40.59,22.39a26.77,26.77,0,0,0,21.37,1.95l.06,0a9.89,9.89,0,0,1,10.12,2.38h0a9.9,9.9,0,0,1,0,14l-15.64,15.63-15.63,15.64a9.9,9.9,0,0,1-14,0h0a9.89,9.89,0,0,1-2.38-10.12h0a26.74,26.74,0,0,0-2-21.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.71,382.47l-40.59,22.39a26.77,26.77,0,0,1-21.37,1.95l-.06,0a9.89,9.89,0,0,0-10.12,2.38h0a9.9,9.9,0,0,0,0,14l15.64,15.63,15.63,15.64a9.9,9.9,0,0,0,14,0h0a9.89,9.89,0,0,0,2.38-10.12h0a26.74,26.74,0,0,1,2-21.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.47,257.71l22.39-40.59a26.77,26.77,0,0,0,1.95-21.37l0-.06a9.89,9.89,0,0,1,2.38-10.12h0a9.9,9.9,0,0,1,14,0l15.63,15.64,15.64,15.63a9.9,9.9,0,0,1,0,14h0a9.89,9.89,0,0,1-10.12,2.38h0a26.74,26.74,0,0,0-21.46,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 320,
    cy: 320,
    r: 112
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344,
    cy: 272,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 336,
    cy: 360,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 264,
    cy: 312,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288,
    cy: 264,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264,
    cy: 368,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 392,
    cy: 320,
    r: 8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.420aa9c913baec8541382e80db19eb99.svg";
export { ForwardRef as ReactComponent };